import { Box } from '@material-ui/core';
import React from 'react';

function DiscoveryAppFinanceScreen() {
  return (
    <Box>
      <Box mb={4} fontSize={22} fontWeight={'fontWeightMedium'}>
        Discovery App Finance
      </Box>
    </Box>
  );
}

export default DiscoveryAppFinanceScreen;
